// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  position: fixed;
  height: 8%;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 10px 30px;
  background: rgba(255, 255, 255, 0.55);
  -webkit-backdrop-filter: blur(8px);
          backdrop-filter: blur(8px);
  z-index: 1000;
  transition: left 0.8s ease 0.4s;
}

.navbar.hidden {
  left: 0;
}

.navbar.visible {
  left: 221px;
}

.navbar-item {
  margin-right: 80px;
}

.logo a,
.home a {
  text-decoration: none;
  color: black;
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  font-size: 20px;
}

.home a:hover {
  color: #007bff;
}

.search input {
  padding: 10px;
  border: 1px solid #4b4a4a;
  border-radius: 20px;
  width: 250px;
  background-color: transparent;
  transition: all 0.3s ease;
  font-size: 16px;
}


.search input:focus {
  outline: none;
  border-color: #1b1b1b;
  box-shadow: 0 0 5px rgba(131, 131, 131, 0.5);
  background-color: white;
  color: rgba(0, 0, 0, 0.541);
}

.search input::placeholder {
  color: #999;
}

.chatbot-nav-link a {
  position: relative;
  text-decoration: none;
}

.chatbot-nav-link a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: transparent;
}

@media only screen and (max-width: 1400px) {
  .navbar {
    height: 13%;
  }
  .navbar.visible {
    left: 191px;
  }
  .navbar-item {
    margin-right: 20px;
  }
.logo a,
.home a {
  text-decoration: none;
  color: black;
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  font-size: 19px;
  }
  
}

@media only screen and (max-width: 750px) {
  .navbar {
    height: 8%;
    padding: 10px 30px;

  }
  .navbar.visible {
    left: 0px;
  }
.logo a,
.home a {
  text-decoration: none;
  color: black;
  font-family:Verdana, Geneva, Tahoma, sans-serif;
  font-size: 17px;
  }
  .search input {
    padding: 10px;
    border: 1px solid #4b4a4a63;
    border-radius: 20px;
    width: 100%;
    background-color: transparent;
    transition: all 0.3s ease;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/pages-style/navbar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,UAAU;EACV,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,YAAY;EACZ,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;AACF;;EAEE,qBAAqB;EACrB,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf;;AAEF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;;EAEpB;EACA;IACE,SAAS;EACX;AACF;;EAEE,qBAAqB;EACrB,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,eAAe;EACjB;AACF","sourcesContent":[".navbar {\n  position: fixed;\n  height: 8%;\n  top: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  padding: 10px 30px;\n  background: rgba(255, 255, 255, 0.55);\n  backdrop-filter: blur(8px);\n  z-index: 1000;\n  transition: left 0.8s ease 0.4s;\n}\n\n.navbar.hidden {\n  left: 0;\n}\n\n.navbar.visible {\n  left: 221px;\n}\n\n.navbar-item {\n  margin-right: 80px;\n}\n\n.logo a,\n.home a {\n  text-decoration: none;\n  color: black;\n  font-family:Verdana, Geneva, Tahoma, sans-serif;\n  font-size: 20px;\n}\n\n.home a:hover {\n  color: #007bff;\n}\n\n.search input {\n  padding: 10px;\n  border: 1px solid #4b4a4a;\n  border-radius: 20px;\n  width: 250px;\n  background-color: transparent;\n  transition: all 0.3s ease;\n  font-size: 16px;\n}\n\n\n.search input:focus {\n  outline: none;\n  border-color: #1b1b1b;\n  box-shadow: 0 0 5px rgba(131, 131, 131, 0.5);\n  background-color: white;\n  color: rgba(0, 0, 0, 0.541);\n}\n\n.search input::placeholder {\n  color: #999;\n}\n\n.chatbot-nav-link a {\n  position: relative;\n  text-decoration: none;\n}\n\n.chatbot-nav-link a::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background-color: transparent;\n}\n\n@media only screen and (max-width: 1400px) {\n  .navbar {\n    height: 13%;\n  }\n  .navbar.visible {\n    left: 191px;\n  }\n  .navbar-item {\n    margin-right: 20px;\n  }\n.logo a,\n.home a {\n  text-decoration: none;\n  color: black;\n  font-family:Verdana, Geneva, Tahoma, sans-serif;\n  font-size: 19px;\n  }\n  \n}\n\n@media only screen and (max-width: 750px) {\n  .navbar {\n    height: 8%;\n    padding: 10px 30px;\n\n  }\n  .navbar.visible {\n    left: 0px;\n  }\n.logo a,\n.home a {\n  text-decoration: none;\n  color: black;\n  font-family:Verdana, Geneva, Tahoma, sans-serif;\n  font-size: 17px;\n  }\n  .search input {\n    padding: 10px;\n    border: 1px solid #4b4a4a63;\n    border-radius: 20px;\n    width: 100%;\n    background-color: transparent;\n    transition: all 0.3s ease;\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
